export const DOCTOR_SPECIALTIES = [
    "Endocrinologist",
    "Dietitian",
    "Cardiologist",
    "Family medicine",
    "Other",
];
const DOCTOR_SPECIALTY_SET = new Set(DOCTOR_SPECIALTIES);
export function isDoctorSpecialty(value) {
    return DOCTOR_SPECIALTY_SET.has(value);
}
export const DOCTOR_SPECIALTY_I18N_KEYS = {
    Endocrinologist: "endocrinologist",
    Dietitian: "dietitian",
    Cardiologist: "cardiologist",
    "Family medicine": "familyMedicine",
    Other: "other",
};
export function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value.trim().toUpperCase());
}
export function normalizeCountryCode(value) {
    const code = value.trim().toUpperCase();
    return isCountryCode(code) ? code : null;
}
